"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icon_1 = require("../components/icon");
function createIcon(options) {
    const { viewBox = "0 0 24 24", displayName } = options;
    const path = react_1.Children.toArray(options.path);
    const Comp = ({ ...props }) => ((0, jsx_runtime_1.jsx)(icon_1.default, { viewBox: viewBox, ...props, displayName: displayName, children: path.length ? path : (0, jsx_runtime_1.jsx)("path", { fill: "currentColor" }) }));
    return Comp;
}
exports.createIcon = createIcon;
